
// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const formattedCurrentDate = date.toISOString().split("T")[0];
//   const oneWeekAgo = new Date(date);
//   oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
//   const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];
//   return {
//     Today: formattedCurrentDate,
//     LastWeek: formattedOneWeekAgo,
//   };
// }

// function InvPrPerformance() {
//   const chartRef = useRef();
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);
//   const [metric, setMetric] = useState("PR");
//   const [idealValue, setIdealValue] = useState(80); // ✅ default PR ideal reference
//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // Fetch inverters and select first by default
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//           params: credentials,
//         });
//         const feederList = res.data.FEED || [];
//         setInverters(feederList);
//         if (feederList.length > 0) {
//           setSelectedKeys([feederList[0].feeder_id]);
//         }
//         setChartData(null);
//       } catch (err) {
//         console.error("Inverter API Error:", err);
//       }
//     }
//     fetchInverters();
//   }, []);

//   // Manual refresh to fetch chart data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) {
//       setChartData(null);
//       return;
//     }
//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     // ✅ Always add Ideal Value line first
//     let idealLabels = [];
//     if (inverters.length > 0) {
//       try {
//         const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//           params: {
//             ...credentials,
//             MTR_NO: inverters[0].feeder_id,
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         });
//         const data = res.data.data || [];
//         idealLabels = data.map((d) => d.DATET);
//       } catch {
//         idealLabels = [];
//       }
//     }
//     labels = idealLabels.length ? idealLabels : [fromDate, toDate];
//     datasets.push({
//       label: "Ideal Value",
//       data: labels.map(() => Number(idealValue)),
//       borderColor: "red",
//       borderDash: [8, 4],
//       fill: false,
//       tension: 0,
//       borderWidth: 2,
//       pointRadius: 0,
//     });

//     // ✅ Add each inverter dataset
//     for (const inv of inverters) {
//       if (!selectedKeys.includes(inv.feeder_id)) continue;

//       try {
//         const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//           params: {
//             ...credentials,
//             MTR_NO: inv.feeder_id,
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         });
//         const apiData = res.data.data || [];
//         if (!labels.length) {
//           labels = apiData.map((d) => d.DATET || d.date || "");
//         }
//         datasets.push({
//           label: inv.name,
//           data: apiData.map((d) => parseFloat(d[metric]) || 0),
//           borderColor: "#" + Math.floor(Math.random() * 16777215).toString(16),
//           fill: false,
//           tension: 0.3,
//         });
//       } catch {
//         // Ignore error for this inverter
//       }
//     }

//     setChartData({ labels, datasets });
//     setLoading(false);
//   };

//   const handleToggle = (key) =>
//     setSelectedKeys((prev) =>
//       prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
//     );


//   // 🔁 Auto refresh chart when Ideal Value changes
//   useEffect(() => {
//     if (chartData) {
//       fetchChartData(); // Refresh the chart automatically
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [idealValue]);

//   return (
//     <div style={{ padding: "10px" }}>
//       <Box sx={{ mb: 1 }}>
//         <Typography variant="h5" fontWeight="bold">
//           Inverter Wise PR Comparison
//         </Typography>
//       </Box>

//       <Paper elevation={2} sx={{ p: 2, mb: 2, bgcolor: "white" }}>
//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: 1,
//             alignItems: "center",
//             mb: 1,
//             fontSize: "0.75rem",
//           }}
//         >
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                   color="primary"
//                   sx={{ p: 0.3, transform: "scale(0.7)" }}
//                 />
//               }
//               label={
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <Typography variant="body2">{inv.name}</Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     [{inv.kwp} kWp]
//                   </Typography>
//                 </Box>
//               }
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* ✅ Ideal Value + Date Filters + Refresh */}
//       <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center", mb: 1 }}>
//         <label style={{ fontSize: 14, fontWeight: 500 }}>Ideal Value:</label>
//         <TextField
//           size="small"
//           type="number"
//           sx={{ width: 70 }}
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <label style={{ fontSize: 14, fontWeight: 500 }}>From:</label>
//         <input
//           type="date"
//           value={fromDate}
//           onChange={(e) => setFromDate(e.target.value)}
//           style={{ height: 32, borderRadius: ".3rem" }}
//         />
//         <label style={{ fontSize: 14, fontWeight: 500 }}>To:</label>
//         <input
//           type="date"
//           value={toDate}
//           onChange={(e) => setToDate(e.target.value)}
//           style={{ height: 32, borderRadius: ".3rem" }}
//         />&nbsp;

//         <TbRefresh
//           style={{ fontSize: "1.5rem", cursor: "pointer" }}
//           onClick={fetchChartData}
//           title="Refresh Chart"
//         />

// <DownloadJpegButton targetRef={chartRef} fileName={`Inverter Wise PR Comparison.jpeg`} />
//       </Box>

//       {/* ✅ Chart Section */}
//       <Paper ref={chartRef}  sx={{ p: 2, bgcolor: "white", height: 350 }}>
//         {loading ? (
//           <Typography sx={{ textAlign: "center", mt: 12, color: "#999" }}>
//             Loading...
//           </Typography>
//         ) : chartData && chartData.labels.length > 0 && chartData.datasets.length > 0 ? (
//           <Line
//             data={chartData}
//             options={{
//               responsive: true,
//               maintainAspectRatio: false,
//               plugins: {
//                 legend: { position: "top", labels: { font: { size: 13 } } },
//               },
//               scales: {
//                 x: { ticks: { font: { size: 11 } } },
//                 y: { ticks: { font: { size: 11 } } },
//               },
//             }}
//           />
//         ) : (
//           <Typography sx={{ textAlign: "center", mt: 12, color: "#bbb" }}>
//             No data to display.
//           </Typography>
//         )}
//       </Paper>
//     </div>
//   );
// }

// export default InvPrPerformance;


// 2.

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Switch,
// } from "@mui/material";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvPrPerformance() {
//   const chartRef = useRef();

//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [isAllSelected, setIsAllSelected] = useState(false);

//   const [chartData, setChartData] = useState(null);

//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);

//   const [idealValue, setIdealValue] = useState(80);
//   const [loading, setLoading] = useState(false);

//   // ✅ Toggle
//   const [chartType, setChartType] = useState("line");

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//           params: credentials,
//         });

//         const list = res.data.FEED || [];
//         setInverters(list);

//         // ✅ Default Select All
//         if (list.length > 0) {
//           const allIds = list.map((inv) => inv.feeder_id);
//           setSelectedKeys(allIds);
//           setIsAllSelected(true);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (e) => {
//     const checked = e.target.checked;
//     setIsAllSelected(checked);

//     if (checked) {
//       const allIds = inverters.map((inv) => inv.feeder_id);
//       setSelectedKeys(allIds);
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Toggle single
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) => {
//       const updated = prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key];

//       setIsAllSelected(updated.length === inverters.length);
//       return updated;
//     });
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     // Ideal Line
//     try {
//       const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//         params: {
//           ...credentials,
//           MTR_NO: selectedKeys[0],
//           DT1: fromDate,
//           DT2: toDate,
//         },
//       });

//       const data = res.data.data || [];
//       labels = data.map((d) => d.DATET);

//       datasets.push({
//         label: "Ideal Value",
//         data: labels.map(() => Number(idealValue)),
//         borderColor: "red",
//         backgroundColor: "red",
//         borderDash: [6, 4],
//         tension: 0,
//         pointRadius: 0,
//         type: "line",
//       });
//     } catch {}

//     // Inverter Data
//     for (const inv of inverters) {
//       if (!selectedKeys.includes(inv.feeder_id)) continue;

//       try {
//         const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//           params: {
//             ...credentials,
//             MTR_NO: inv.feeder_id,
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         });

//         const apiData = res.data.data || [];

//         datasets.push({
//           label: inv.name,
//           data: apiData.map((d) => parseFloat(d.PR) || 0),
//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           backgroundColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           tension: 0.4,
//           pointRadius: 2,
//         });
//       } catch {}
//     }

//     setChartData({ labels, datasets });
//     setLoading(false);
//   };

//   useEffect(() => {
//     if (chartData) fetchChartData();
//   }, [idealValue]);

//   return (
//     <div style={{ padding: "10px" }}>
//       <Typography variant="h5" fontWeight="bold" mb={1}>
//         Inverter Wise PR Comparison
//       </Typography>

//       {/* ✅ Select All + Checkbox */}
//       <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
//         <FormControlLabel
//           control={
//             <Switch
//               checked={isAllSelected}
//               onChange={handleSelectAll}
//             />
//           }
//           label="Select All Inverters"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               sx={{ "& .MuiTypography-root": { fontSize: "12px" } }}
//               control={
//                 <Checkbox
//                   size="small"
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={`${inv.name} [${inv.kwp} kWp]`}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 0, alignItems: "center" }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <TbRefresh style={{ cursor: "pointer" }} onClick={fetchChartData} />

//         <DownloadJpegButton targetRef={chartRef} fileName="PR Chart.jpeg" />
//       </Box>

//       {/* Toggle */}
//       <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
//         <Box sx={{ display: "flex", background: "#e0e0e0", borderRadius: "20px", p: "3px" }}>
//           <Box
//             onClick={() => setChartType("line")}
//             sx={{
//               px: 2,
//               py: 0.5,
//               cursor: "pointer",
//               borderRadius: "20px",
//               background: chartType === "line" ? "#1976d2" : "transparent",
//               color: chartType === "line" ? "#fff" : "#000",
//             }}
//           >
//             📈 Line
//           </Box>

//           <Box
//             onClick={() => setChartType("bar")}
//             sx={{
//               px: 2,
//               py: 0.5,
//               cursor: "pointer",
//               borderRadius: "20px",
//               background: chartType === "bar" ? "#1976d2" : "transparent",
//               color: chartType === "bar" ? "#fff" : "#000",
//             }}
//           >
//             📊 Bar
//           </Box>
//         </Box>
//       </Box>

//       {/* Chart */}
//       <Paper ref={chartRef} sx={{ p: 2, height: 350 }}>
//         {loading ? (
//           <Typography align="center" mt={10}>Loading...</Typography>
//         ) : chartData ? (
//           chartType === "line" ? (
//             <Line data={chartData} options={{ responsive: true, maintainAspectRatio: false }} />
//           ) : (
//             <Bar data={chartData} options={{ responsive: true, maintainAspectRatio: false }} />
//           )
//         ) : (
//           <Typography align="center" mt={10}>No Data</Typography>
//         )}
//       </Paper>
//     </div>
//   );
// }

// export default InvPrPerformance;

// 3. correct

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Switch,
// } from "@mui/material";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvPrPerformance() {
//   const chartRef = useRef();

//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [isAllSelected, setIsAllSelected] = useState(false);
//   const [chartData, setChartData] = useState(null);

//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);

//   const [idealValue, setIdealValue] = useState(80);
//   const [loading, setLoading] = useState(false);

//   const [chartType, setChartType] = useState("line");

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//           params: credentials,
//         });

//         const list = res.data.FEED || [];
//         setInverters(list);

//         // ✅ Default → only first inverter selected
//         if (list.length > 0) {
//           setSelectedKeys([list[0].feeder_id]);
//           setIsAllSelected(false);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (e) => {
//     const checked = e.target.checked;
//     setIsAllSelected(checked);

//     if (checked) {
//       const allIds = inverters.map((inv) => inv.feeder_id);
//       setSelectedKeys(allIds);
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Toggle single
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) => {
//       const updated = prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key];

//       setIsAllSelected(updated.length === inverters.length);
//       return updated;
//     });
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) {
//       setChartData(null);
//       return;
//     }

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     // Ideal Line
//     try {
//       const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//         params: {
//           ...credentials,
//           MTR_NO: selectedKeys[0],
//           DT1: fromDate,
//           DT2: toDate,
//         },
//       });

//       const data = res.data.data || [];
//       labels = data.map((d) => d.DATET);

//       datasets.push({
//         label: "Ideal Value",
//         data: labels.map(() => Number(idealValue)),
//         borderColor: "red",
//         backgroundColor: "red",
//         borderDash: [6, 4],
//         tension: 0,
//         pointRadius: 0,
//         type: "line",
//       });
//     } catch {}

//     // Inverter Data
//     for (const inv of inverters) {
//       if (!selectedKeys.includes(inv.feeder_id)) continue;

//       try {
//         const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//           params: {
//             ...credentials,
//             MTR_NO: inv.feeder_id,
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         });

//         const apiData = res.data.data || [];

//         datasets.push({
//           label: inv.name,
//           data: apiData.map((d) => parseFloat(d.PR) || 0),
//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           backgroundColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           tension: 0.4,
//           pointRadius: 2,
//         });
//       } catch {}
//     }

//     setChartData({ labels, datasets });
//     setLoading(false);
//   };

//   // 🔁 Auto refresh on selection change
//   useEffect(() => {
//     if (selectedKeys.length > 0) {
//       fetchChartData();
//     }
//   }, [selectedKeys]);

//   // 🔁 Ideal value change refresh
//   useEffect(() => {
//     if (chartData) fetchChartData();
//   }, [idealValue]);

//   return (
//     <div style={{ padding: "10px" }}>
//       <Typography variant="h5" fontWeight="bold" mb={1}>
//         Inverter Wise PR Comparison
//       </Typography>

//       {/* Select All + Checkbox */}
//       <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
//         <FormControlLabel
//           control={
//             <Switch
//               checked={isAllSelected}
//               onChange={handleSelectAll}
//             />
//           }
//           label="Select All Inverters"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               sx={{ "& .MuiTypography-root": { fontSize: "12px" } }}
//               control={
//                 <Checkbox
//                   size="small"
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={`${inv.name} [${inv.kwp} kWp]`}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 1, alignItems: "center" }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <TbRefresh style={{ cursor: "pointer" }} onClick={fetchChartData} />

//         <DownloadJpegButton targetRef={chartRef} fileName="PR Chart.jpeg" />
//       </Box>

//       {/* Toggle */}
//       <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
//         <Box sx={{ display: "flex", background: "#e0e0e0", borderRadius: "20px", p: "3px" }}>
//           <Box
//             onClick={() => setChartType("line")}
//             sx={{
//               px: 2,
//               py: 0.5,
//               cursor: "pointer",
//               borderRadius: "20px",
//               background: chartType === "line" ? "#1976d2" : "transparent",
//               color: chartType === "line" ? "#fff" : "#000",
//             }}
//           >
//             📈 Line
//           </Box>

//           <Box
//             onClick={() => setChartType("bar")}
//             sx={{
//               px: 2,
//               py: 0.5,
//               cursor: "pointer",
//               borderRadius: "20px",
//               background: chartType === "bar" ? "#1976d2" : "transparent",
//               color: chartType === "bar" ? "#fff" : "#000",
//             }}
//           >
//             📊 Bar
//           </Box>
//         </Box>
//       </Box>

//       {/* Chart */}
//       <Paper ref={chartRef} sx={{ p: 2, height: 350 }}>
//         {loading ? (
//           <Typography align="center" mt={10}>Loading...</Typography>
//         ) : chartData ? (
//           chartType === "line" ? (
//             <Line data={chartData} options={{ responsive: true, maintainAspectRatio: false }} />
//           ) : (
//             <Bar data={chartData} options={{ responsive: true, maintainAspectRatio: false }} />
//           )
//         ) : (
//           <Typography align="center" mt={10}>No Data</Typography>
//         )}
//       </Paper>
//     </div>
//   );
// }

// export default InvPrPerformance;

// 4.

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Tabs,
//   Tab,
// } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvPrPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);

//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);
//   const [idealValue, setIdealValue] = useState(80);

//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//         params: credentials,
//       });

//       const list = res.data.FEED || [];
//       setInverters(list);

//       if (list.length > 0) {
//         setSelectedKeys([list[0].feeder_id]);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Toggle inverter
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     // First inverter for labels
//     const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//       params: {
//         ...credentials,
//         MTR_NO: selectedKeys[0],
//         DT1: fromDate,
//         DT2: toDate,
//       },
//     });

//     const data = res.data.data || [];
//     labels = data.map((d) => d.DATET);

//     // Ideal Line
//     datasets.push({
//       label: "Ideal",
//       data: labels.map(() => idealValue),
//       borderColor: "red",
//       backgroundColor: "red",
//       borderDash: [5, 5],
//       type: "line",
//     });

//     // Inverter Data
//     for (const inv of inverters) {
//       if (!selectedKeys.includes(inv.feeder_id)) continue;

//       const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//         params: {
//           ...credentials,
//           MTR_NO: inv.feeder_id,
//           DT1: fromDate,
//           DT2: toDate,
//         },
//       });

//       const apiData = res.data.data || [];

//       datasets.push({
//         label: inv.name,
//         data: apiData.map((d) => parseFloat(d.PR) || 0),
//         backgroundColor:
//           "#" + Math.floor(Math.random() * 16777215).toString(16),
//       });
//     }

//     setChartData({ labels, datasets });
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔹 Chart Options
//   const verticalBarOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//   };

//   const horizontalBarOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     indexAxis: "y", // 🔥 IMPORTANT
//     plugins: {
//       legend: {
//         position: "top",
//       },
//     },
//     scales: {
//       x: {
//         beginAtZero: true,
//         max: 100,
//       },
//     },
//   };

//   return (
//     <div style={{ padding: "10px" }}>
//       <Typography variant="h5" fontWeight="bold" mb={2}>
//         Inverter Wise PR Comparison
//       </Typography>

//       {/* Tabs */}
//       <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//         <Tab label="Bar Chart" />
//         <Tab label="Horizontal Bar" />
//         <Tab label="Line Chart" />
//       </Tabs>

//       {/* Checkbox */}
//       <Paper sx={{ p: 2, my: 2 }}>
//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <TbRefresh onClick={fetchChartData} style={{ cursor: "pointer" }} />

//         <DownloadJpegButton targetRef={chartRef} fileName="Chart.jpeg" />
//       </Box>

//       {/* Chart */}
//       <Paper ref={chartRef} sx={{ p: 2, height: 400 }}>
//         {loading ? (
//           <Typography align="center">Loading...</Typography>
//         ) : chartData ? (
//           <>
//             {tab === 0 && <Bar data={chartData} options={verticalBarOptions} />}
//             {tab === 1 && <Bar data={chartData} options={horizontalBarOptions} />}
//             {tab === 2 && <Line data={chartData} />}
//           </>
//         ) : (
//           <Typography align="center">No Data</Typography>
//         )}
//       </Paper>
//     </div>
//   );
// }

// export default InvPrPerformance;

// 5. isme sabhi me values show ho rahi hai

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Tabs,
//   Tab,
// } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvPrPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);

//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);
//   const [idealValue, setIdealValue] = useState(80);

//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//           params: credentials,
//         });

//         const list = res.data.FEED || [];
//         setInverters(list);

//         if (list.length > 0) {
//           setSelectedKeys([list[0].feeder_id]);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Toggle inverter
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     try {
//       // Base inverter for labels
//       const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//         params: {
//           ...credentials,
//           MTR_NO: selectedKeys[0],
//           DT1: fromDate,
//           DT2: toDate,
//         },
//       });

//       const baseData = res.data.data || [];
//       labels = baseData.map((d) => d.DATET);

//       // Ideal Line
//       datasets.push({
//         label: "Ideal",
//         data: labels.map(() => Number(idealValue)),
//         borderColor: "red",
//         backgroundColor: "red",
//         borderDash: [5, 5],
//         tension: 0,
//         pointRadius: 0,
//         fill: false,
//       });

//       // Inverter data
//       for (const inv of inverters) {
//         if (!selectedKeys.includes(inv.feeder_id)) continue;

//         const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//           params: {
//             ...credentials,
//             MTR_NO: inv.feeder_id,
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         });

//         const apiData = res.data.data || [];

//         // 🔥 Align data with labels
//         const dataMap = {};
//         apiData.forEach((d) => {
//           dataMap[d.DATET] = parseFloat(d.PR) || 0;
//         });

//         datasets.push({
//           label: inv.name,
//           data: labels.map((label) => dataMap[label] || 0),

//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           backgroundColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),

//           tension: 0.4,
//           pointRadius: 3,
//           fill: false,
//         });
//       }

//       setChartData({ labels, datasets });
//     } catch (err) {
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔹 Options
//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//   };

//   const horizontalBarOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     indexAxis: "y",
//     scales: {
//       x: {
//         beginAtZero: true,
//         max: 100,
//       },
//       y: {
//         ticks: {
//           autoSkip: false,
//         },
//       },
//     },
//   };

//   const lineOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     scales: {
//       y: {
//         beginAtZero: true,
//         max: 100,
//       },
//     },
//   };

//   return (
//     <div style={{ padding: "10px" }}>
//       <Typography variant="h5" fontWeight="bold" mb={2}>
//         Inverter Wise PR Comparison
//       </Typography>

//       {/* Tabs */}
//       <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//         <Tab label="Bar Chart" />
//         <Tab label="Horizontal Bar" />
//         <Tab label="Line Chart" />
//       </Tabs>

//       {/* Checkbox */}
//       <Paper sx={{ p: 2, my: 2 }}>
//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <TbRefresh onClick={fetchChartData} style={{ cursor: "pointer" }} />

//         <DownloadJpegButton targetRef={chartRef} fileName="Chart.jpeg" />
//       </Box>

//       {/* Chart */}
//       <Paper ref={chartRef} sx={{ p: 2 }}>
//         <Box sx={{ height: "300px", width: "100%" }}>
//           {loading ? (
//             <Typography align="center">Loading...</Typography>
//           ) : chartData ? (
//             <>
//               {tab === 0 && <Bar data={chartData} options={commonOptions} />}
//               {tab === 1 && <Bar data={chartData} options={horizontalBarOptions} />}
//               {tab === 2 && <Line data={chartData} options={lineOptions} />}
//             </>
//           ) : (
//             <Typography align="center">No Data</Typography>
//           )}
//         </Box>
//       </Paper>
//     </div>
//   );
// }

// export default InvPrPerformance;

// 5.

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Tabs,
//   Tab,
// } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels // ✅ plugin
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvPrPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);

//   const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//   const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);
//   const [idealValue, setIdealValue] = useState(80);

//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//           params: credentials,
//         });

//         const list = res.data.FEED || [];
//         setInverters(list);

//         if (list.length > 0) {
//           setSelectedKeys([list[0].feeder_id]);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Toggle inverter
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     try {
//       const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//         params: {
//           ...credentials,
//           MTR_NO: selectedKeys[0],
//           DT1: fromDate,
//           DT2: toDate,
//         },
//       });

//       const baseData = res.data.data || [];
//       labels = baseData.map((d) => d.DATET);

//       // Ideal Line
//       datasets.push({
//         label: "Ideal",
//         data: labels.map(() => Number(idealValue)),
//         borderColor: "red",
//         backgroundColor: "red",
//         borderDash: [5, 5],
//         tension: 0,
//         pointRadius: 0,
//         fill: false,
//       });

//       for (const inv of inverters) {
//         if (!selectedKeys.includes(inv.feeder_id)) continue;

//         const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//           params: {
//             ...credentials,
//             MTR_NO: inv.feeder_id,
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         });

//         const apiData = res.data.data || [];

//         const dataMap = {};
//         apiData.forEach((d) => {
//           dataMap[d.DATET] = parseFloat(d.PR) || 0;
//         });

//         datasets.push({
//           label: inv.name,
//           data: labels.map((label) => dataMap[label] || 0),
//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           backgroundColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           tension: 0.4,
//           pointRadius: 3,
//           fill: false,
//         });
//       }

//       setChartData({ labels, datasets });
//     } catch (err) {
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔹 OPTIONS

//   // ❌ No values
//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       datalabels: {
//         display: false,
//       },
//     },
//   };

//   // ❌ No values
//   const lineOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       datalabels: {
//         display: false,
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         max: 100,
//       },
//     },
//   };

//   // ✅ Show values RIGHT side
//   const horizontalBarOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     indexAxis: "y",
//     plugins: {
//       datalabels: {
//         display: true,
//         anchor: "end",
//         align: "right",
//         color: "#000",
//         formatter: (value) => value.toFixed(2),
//         font: {
//           weight: "bold",
//         },
//       },
//     },
//     scales: {
//       x: {
//         beginAtZero: true,
//         max: 100,
//       },
//       y: {
//         ticks: {
//           autoSkip: false,
//         },
//       },
//     },
//   };

//   return (
//     <div style={{ padding: "10px" }}>
//       <Typography variant="h5" fontWeight="bold" mb={2}>
//         Inverter Wise PR Comparison
//       </Typography>

//       {/* Tabs */}
//       <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//         <Tab label="Bar Chart" />
//         <Tab label="Horizontal Bar" />
//         <Tab label="Line Chart" />
//       </Tabs>

//       {/* Checkbox */}
//       <Paper sx={{ p: 2, my: 2 }}>
//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <TbRefresh onClick={fetchChartData} style={{ cursor: "pointer" }} />

//         <DownloadJpegButton targetRef={chartRef} fileName="Chart.jpeg" />
//       </Box>

//       {/* Chart */}
//       <Paper ref={chartRef} sx={{ p: 2 }}>
//         <Box sx={{ height: "300px", width: "100%" }}>
//           {loading ? (
//             <Typography align="center">Loading...</Typography>
//           ) : chartData ? (
//             <>
//               {tab === 0 && <Bar data={chartData} options={commonOptions} />}
//               {tab === 1 && <Bar data={chartData} options={horizontalBarOptions} />}
//               {tab === 2 && <Line data={chartData} options={lineOptions} />}
//             </>
//           ) : (
//             <Typography align="center">No Data</Typography>
//           )}
//         </Box>
//       </Paper>
//     </div>
//   );
// }

// export default InvPrPerformance;

// 6.correct code

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Tabs,
//   Tab,
//   Switch,
// } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvPrPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);

//   const [selectAll, setSelectAll] = useState(false);

//   const [fromDate, setFromDate] = useState(
//     getDateTimeForDashboardTab1().LastWeek
//   );
//   const [toDate, setToDate] = useState(
//     getDateTimeForDashboardTab1().Today
//   );
//   const [idealValue, setIdealValue] = useState(80);

//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           {
//             params: credentials,
//           }
//         );

//         const list = res.data.FEED || [];
//         setInverters(list);

//         if (list.length > 0) {
//           setSelectedKeys([list[0].feeder_id]);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All Logic
//   const handleSelectAll = (checked) => {
//     setSelectAll(checked);

//     if (checked) {
//       setSelectedKeys(inverters.map((inv) => inv.feeder_id));
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Sync switch with manual selection
//   useEffect(() => {
//     if (
//       selectedKeys.length === inverters.length &&
//       inverters.length > 0
//     ) {
//       setSelectAll(true);
//     } else {
//       setSelectAll(false);
//     }
//   }, [selectedKeys, inverters]);

//   // 🔹 Toggle single inverter
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     try {
//       const res = await axios.get(
//         `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//         {
//           params: {
//             ...credentials,
//             MTR_NO: selectedKeys[0],
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         }
//       );

//       const baseData = res.data.data || [];
//       labels = baseData.map((d) => d.DATET);

//       // Ideal Line
//       datasets.push({
//         label: "Ideal",
//         data: labels.map(() => Number(idealValue)),
//         borderColor: "red",
//         backgroundColor: "red",
//         borderDash: [5, 5],
//         tension: 0,
//         pointRadius: 0,
//         fill: false,
//       });

//       for (const inv of inverters) {
//         if (!selectedKeys.includes(inv.feeder_id)) continue;

//         const res = await axios.get(
//           `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//           {
//             params: {
//               ...credentials,
//               MTR_NO: inv.feeder_id,
//               DT1: fromDate,
//               DT2: toDate,
//             },
//           }
//         );

//         const apiData = res.data.data || [];

//         const dataMap = {};
//         apiData.forEach((d) => {
//           dataMap[d.DATET] = parseFloat(d.PR) || 0;
//         });

//         datasets.push({
//           label: inv.name,
//           data: labels.map((label) => dataMap[label] || 0),
//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           backgroundColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           tension: 0.4,
//           pointRadius: 3,
//           fill: false,
//         });
//       }

//       setChartData({ labels, datasets });
//     } catch (err) {
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔹 OPTIONS
//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       datalabels: { display: false },
//     },
//   };

//   const lineOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       datalabels: { display: false },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         max: 100,
//       },
//     },
//   };

//   const horizontalBarOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     indexAxis: "y",
//     plugins: {
//       datalabels: {
//         display: true,
//         anchor: "end",
//         align: "right",
//         color: "#000",
//         formatter: (value) => value.toFixed(2),
//         font: { weight: "bold" },
//       },
//     },
//     scales: {
//       x: {
//         beginAtZero: true,
//         max: 100,
//       },
//       y: {
//         ticks: { autoSkip: false },
//       },
//     },
//   };

//   return (
//     <div style={{ padding: "10px" }}>
//       <Typography variant="h5" fontWeight="bold" mb={2}>
//         Inverter Wise PR Comparison
//       </Typography>

//       {/* Tabs */}
//       <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//         <Tab label="Bar Chart" />
//         <Tab label="Horizontal Bar" />
//         <Tab label="Line Chart" />
//       </Tabs>

//       {/* Checkbox + Select All */}
//       <Paper sx={{ p: 2, my: 2 }}>
//         <FormControlLabel
//           control={
//             <Switch
//               checked={selectAll}
//               onChange={(e) =>
//                 handleSelectAll(e.target.checked)
//               }
//             />
//           }
//           label="Select All Inverters"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() =>
//                     handleToggle(inv.feeder_id)
//                   }
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) =>
//             setIdealValue(e.target.value)
//           }
//         />

//         <input
//           type="date"
//           value={fromDate}
//           onChange={(e) =>
//             setFromDate(e.target.value)
//           }
//         />
//         <input
//           type="date"
//           value={toDate}
//           onChange={(e) =>
//             setToDate(e.target.value)
//           }
//         />

//         <TbRefresh
//           onClick={fetchChartData}
//           style={{ cursor: "pointer" }}
//         />

//         <DownloadJpegButton
//           targetRef={chartRef}
//           fileName="Chart.jpeg"
//         />
//       </Box>

//       {/* Chart */}
//       <Paper ref={chartRef} sx={{ p: 2 }}>
//         <Box sx={{ height: "300px", width: "100%" }}>
//           {loading ? (
//             <Typography align="center">
//               Loading...
//             </Typography>
//           ) : chartData ? (
//             <>
//               {tab === 0 && (
//                 <Bar data={chartData} options={commonOptions} />
//               )}
//               {tab === 1 && (
//                 <Bar
//                   data={chartData}
//                   options={horizontalBarOptions}
//                 />
//               )}
//               {tab === 2 && (
//                 <Line data={chartData} options={lineOptions} />
//               )}
//             </>
//           ) : (
//             <Typography align="center">
//               No Data
//             </Typography>
//           )}
//         </Box>
//       </Paper>
//     </div>
//   );
// }

// export default InvPrPerformance;

// 7. CORRECT CODE YESTERDAY

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Tabs,
//   Tab,
//   Switch,
// } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvPrPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);

//   const [selectAll, setSelectAll] = useState(false);

//   const [fromDate, setFromDate] = useState(
//     getDateTimeForDashboardTab1().LastWeek
//   );
//   const [toDate, setToDate] = useState(
//     getDateTimeForDashboardTab1().Today
//   );
//   const [idealValue, setIdealValue] = useState(80);

//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           { params: credentials }
//         );

//         const list = res.data.FEED || [];
//         setInverters(list);

//         if (list.length > 0) {
//           setSelectedKeys([list[0].feeder_id]);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (checked) => {
//     setSelectAll(checked);
//     if (checked) {
//       setSelectedKeys(inverters.map((inv) => inv.feeder_id));
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Sync switch
//   useEffect(() => {
//     if (
//       selectedKeys.length === inverters.length &&
//       inverters.length > 0
//     ) {
//       setSelectAll(true);
//     } else {
//       setSelectAll(false);
//     }
//   }, [selectedKeys, inverters]);

//   // 🔹 Toggle inverter
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch chart data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     try {
//       const res = await axios.get(
//         `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//         {
//           params: {
//             ...credentials,
//             MTR_NO: selectedKeys[0],
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         }
//       );

//       const baseData = res.data.data || [];
//       labels = baseData.map((d) => d.DATET);

//       // Ideal line
//       datasets.push({
//         label: "Ideal",
//         data: labels.map(() => Number(idealValue)),
//         borderColor: "red",
//         backgroundColor: "red",
//         borderDash: [5, 5],
//         tension: 0,
//         pointRadius: 0,
//         fill: false,
//       });

//       for (const inv of inverters) {
//         if (!selectedKeys.includes(inv.feeder_id)) continue;

//         const res = await axios.get(
//           `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//           {
//             params: {
//               ...credentials,
//               MTR_NO: inv.feeder_id,
//               DT1: fromDate,
//               DT2: toDate,
//             },
//           }
//         );

//         const apiData = res.data.data || [];

//         const dataMap = {};
//         apiData.forEach((d) => {
//           dataMap[d.DATET] = parseFloat(d.PR) || 0;
//         });

//         datasets.push({
//           label: inv.name,
//           data: labels.map((label) => dataMap[label] || 0),
//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           backgroundColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           tension: 0.4,
//           pointRadius: 3,
//           fill: false,
//         });
//       }

//       setChartData({ labels, datasets });
//     } catch (err) {
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔹 Chart options
//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: { datalabels: { display: false } },
//   };

//   const lineOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: { datalabels: { display: false } },
//     scales: {
//       y: { beginAtZero: true, max: 100 },
//     },
//   };

//   const horizontalBarOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     indexAxis: "y",
//     plugins: {
//       datalabels: {
//         display: true,
//         anchor: "end",
//         align: "right",
//         color: "#000",
//         formatter: (value) => value.toFixed(2),
//         font: { weight: "bold" },
//       },
//     },
//     scales: {
//       x: { beginAtZero: true, max: 100 },
//     },
//   };

//   return (
//     <div style={{ padding: "10px" }}>
//       {/* 🔹 Header Row */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 2,
//           flexWrap: "wrap",
//         }}
//       >
//         <Typography variant="h5" fontWeight="bold">
//           Inverter Wise PR Comparison
//         </Typography>

//         <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//           <Tab label="Bar Chart" />
//           <Tab label="Horizontal Bar" />
//           <Tab label="Line Chart" />
//         </Tabs>
//       </Box>

//       {/* 🔹 Select All + Checkboxes */}
//       <Paper sx={{ p: 2, my: 2 }}>
//         <FormControlLabel
//           control={
//             <Switch
//               checked={selectAll}
//               onChange={(e) =>
//                 handleSelectAll(e.target.checked)
//               }
//             />
//           }
//           label="Select All Inverters"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() =>
//                     handleToggle(inv.feeder_id)
//                   }
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* 🔹 Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input
//           type="date"
//           value={fromDate}
//           onChange={(e) => setFromDate(e.target.value)}
//         />
//         <input
//           type="date"
//           value={toDate}
//           onChange={(e) => setToDate(e.target.value)}
//         />

//         {/* 🔥 Updated Refresh Icon */}
//         <TbRefresh
//           size={30}
//           onClick={fetchChartData}
//           style={{
//             cursor: "pointer",
//             color: "#1976d2",
//             transition: "0.3s",
//           }}
//           onMouseOver={(e) =>
//             (e.currentTarget.style.transform = "rotate(90deg)")
//           }
//           onMouseOut={(e) =>
//             (e.currentTarget.style.transform = "rotate(0deg)")
//           }
//         />

//         <DownloadJpegButton
//           targetRef={chartRef}
//           fileName="Chart.jpeg"
//         />
//       </Box>

//       {/* 🔹 Chart */}
//       <Paper ref={chartRef} sx={{ p: 2 }}>
//         <Box sx={{ height: "300px" }}>
//           {loading ? (
//             <Typography align="center">Loading...</Typography>
//           ) : chartData ? (
//             <>
//               {tab === 0 && (
//                 <Bar data={chartData} options={commonOptions} />
//               )}
//               {tab === 1 && (
//                 <Bar data={chartData} options={horizontalBarOptions} />
//               )}
//               {tab === 2 && (
//                 <Line data={chartData} options={lineOptions} />
//               )}
//             </>
//           ) : (
//             <Typography align="center">No Data</Typography>
//           )}
//         </Box>
//       </Paper>
//     </div>
//   );
// }

// export default InvPrPerformance;

// 8. bar chart me hai ideal value 

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Tabs,
//   Tab,
//   Switch,
// } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// // ❌ Removed ChartDataLabels from global
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvPrPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);

//   const [selectAll, setSelectAll] = useState(false);

//   const [fromDate, setFromDate] = useState(
//     getDateTimeForDashboardTab1().LastWeek
//   );
//   const [toDate, setToDate] = useState(
//     getDateTimeForDashboardTab1().Today
//   );
//   const [idealValue, setIdealValue] = useState(80);

//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           { params: credentials }
//         );

//         const list = res.data.FEED || [];
//         setInverters(list);

//         if (list.length > 0) {
//           setSelectedKeys([list[0].feeder_id]);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (checked) => {
//     setSelectAll(checked);
//     if (checked) {
//       setSelectedKeys(inverters.map((inv) => inv.feeder_id));
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Sync switch
//   useEffect(() => {
//     setSelectAll(
//       selectedKeys.length === inverters.length &&
//         inverters.length > 0
//     );
//   }, [selectedKeys, inverters]);

//   // 🔹 Toggle inverter
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch chart data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     try {
//       const res = await axios.get(
//         `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//         {
//           params: {
//             ...credentials,
//             MTR_NO: selectedKeys[0],
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         }
//       );

//       const baseData = res.data.data || [];
//       labels = baseData.map((d) => d.DATET);

//       // Ideal line
//       datasets.push({
//         label: "Ideal",
//         data: labels.map(() => Number(idealValue)),
//         borderColor: "red",
//         borderDash: [5, 5],
//         tension: 0,
//         pointRadius: 0,
//         fill: false,
//       });

//       for (const inv of inverters) {
//         if (!selectedKeys.includes(inv.feeder_id)) continue;
// //  console.log("Calling API for Feeder:", inv.feeder_id);
//         const res = await axios.get(
//           `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//           {
//             params: {
//               ...credentials,
//               MTR_NO: inv.feeder_id,
//               DT1: fromDate,
//               DT2: toDate,
//             },
//           }
//         );

//         const apiData = res.data.data || [];

//         const dataMap = {};
//         apiData.forEach((d) => {
//           dataMap[d.DATET] = parseFloat(d.PR) || 0;
//         });

//         datasets.push({
//           label: inv.name,
//           data: labels.map((label) => dataMap[label] || 0),
//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           backgroundColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           tension: 0.4,
//           pointRadius: 3,
//           fill: false,
//         });
//       }

//       setChartData({ labels, datasets });
//     } catch (err) {
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔹 Common Options
//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       datalabels: { display: false }, // ✅ disable globally
//     },
//   };

//   const lineOptions = {
//     ...commonOptions,
//     scales: {
//       y: { beginAtZero: true, max: 100 },
//     },
//   };

//   const barOptions = {
//     ...commonOptions,
//   };

//   // ✅ ONLY Horizontal Bar me label show hoga
//   const horizontalBarOptions = {
//     ...commonOptions,
//     indexAxis: "y",
//     plugins: {
//       datalabels: {
//         display: true,
//         anchor: "end",
//         align: "right",
//         formatter: (value) =>
//           value ? Number(value).toFixed(2) : "0",
//         color: (context) => {
//           const val = context.raw;
//           return val < idealValue ? "#e53935" : "#2e7d32";
//         },
//         font: { weight: "bold" },
//       },
//     },
//     scales: {
//       x: { beginAtZero: true, max: 100 },
//     },
//   };

//   return (
//     <div style={{ padding: "10px" }}>
//       {/* Header */}
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//         <Typography variant="h5" fontWeight="bold">
//           Inverter Wise PR Comparison
//         </Typography>

//         <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//           <Tab label="Bar Chart" />
//           <Tab label="Horizontal Bar" />
//           <Tab label="Line Chart" />
//         </Tabs>
//       </Box>

//       {/* Select */}
//       <Paper sx={{ p: 2, my: 2 }}>
//         <FormControlLabel
//           control={
//             <Switch
//               checked={selectAll}
//               onChange={(e) => handleSelectAll(e.target.checked)}
//             />
//           }
//           label="Select All Inverters"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <TbRefresh size={30} onClick={fetchChartData} style={{ cursor: "pointer", color: "#1976d2" }} />

//         <DownloadJpegButton targetRef={chartRef} fileName="Chart.jpeg" />
//       </Box>

//       {/* Chart */}
//       <Paper ref={chartRef} sx={{ p: 2 }}>
//         <Box sx={{ height: "300px" }}>
//           {loading ? (
//             <Typography align="center">Loading...</Typography>
//           ) : chartData ? (
//             <>
//               {tab === 0 && <Bar data={chartData} options={barOptions} />}

//               {tab === 1 && (
//                 <Bar
//                   data={chartData}
//                   options={horizontalBarOptions}
//                   plugins={[ChartDataLabels]} // ✅ only here
//                 />
//               )}

//               {tab === 2 && <Line data={chartData} options={lineOptions} />}
//             </>
//           ) : (
//             <Typography align="center">No Data</Typography>
//           )}
//         </Box>
//       </Paper>
//     </div>
//   );
// }

// export default InvPrPerformance;

//9. idela line me


// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import annotationPlugin from "chartjs-plugin-annotation";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   TextField,
//   Tabs,
//   Tab,
//   Switch,
// } from "@mui/material";
// import { TbRefresh } from "react-icons/tb";
// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// // ✅ Register plugins
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   annotationPlugin
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const today = date.toISOString().split("T")[0];
//   const lastWeek = new Date(date);
//   lastWeek.setDate(lastWeek.getDate() - 7);

//   return {
//     Today: today,
//     LastWeek: lastWeek.toISOString().split("T")[0],
//   };
// }

// function InvPrPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [selectAll, setSelectAll] = useState(false);

//   const [fromDate, setFromDate] = useState(
//     getDateTimeForDashboardTab1().LastWeek
//   );
//   const [toDate, setToDate] = useState(
//     getDateTimeForDashboardTab1().Today
//   );
//   const [idealValue, setIdealValue] = useState(80);

//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       const res = await axios.get(
//         `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//         { params: credentials }
//       );

//       const list = res.data.FEED || [];
//       setInverters(list);

//       if (list.length > 0) {
//         setSelectedKeys([list[0].feeder_id]);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (checked) => {
//     setSelectAll(checked);
//     setSelectedKeys(
//       checked ? inverters.map((i) => i.feeder_id) : []
//     );
//   };

//   useEffect(() => {
//     setSelectAll(
//       selectedKeys.length === inverters.length &&
//         inverters.length > 0
//     );
//   }, [selectedKeys, inverters]);

//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     let labels = [];
//     let datasets = [];

//     try {
//       const baseRes = await axios.get(
//         `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//         {
//           params: {
//             ...credentials,
//             MTR_NO: selectedKeys[0],
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         }
//       );

//       const baseData = baseRes.data.data || [];
//       labels = baseData.map((d) => d.DATET);

//       for (const inv of inverters) {
//         if (!selectedKeys.includes(inv.feeder_id)) continue;

//         const res = await axios.get(
//           `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//           {
//             params: {
//               ...credentials,
//               MTR_NO: inv.feeder_id,
//               DT1: fromDate,
//               DT2: toDate,
//             },
//           }
//         );

//         const apiData = res.data.data || [];

//         const dataMap = {};
//         apiData.forEach((d) => {
//           dataMap[d.DATET] = parseFloat(d.PR) || 0;
//         });

//         datasets.push({
//           label: inv.name,
//           data: labels.map((l) => dataMap[l] || 0),
//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           backgroundColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           tension: 0.4,
//           pointRadius: 3,
//         });
//       }

//       setChartData({ labels, datasets });
//     } catch (err) {
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔥 Ideal Line Config
//   const idealLineY = {
//     type: "line",
//     yMin: idealValue,
//     yMax: idealValue,
//     borderColor: "red",
//     borderWidth: 2,
//     borderDash: [6, 6],
//     label: {
//       display: true,
//       content: `Ideal: ${idealValue}`,
//       position: "end",
//     },
//   };

//   const idealLineX = {
//     type: "line",
//     xMin: idealValue,
//     xMax: idealValue,
//     borderColor: "red",
//     borderWidth: 2,
//     borderDash: [6, 6],
//     label: {
//       display: true,
//       content: `Ideal: ${idealValue}`,
//       position: "end",
//     },
//   };

//   // 🔹 Options
//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       datalabels: { display: false },
//     },
//   };

//   const barOptions = {
//     ...commonOptions,
//     scales: {
//       y: { beginAtZero: true, max: 100 },
//     },
//     plugins: {
//       ...commonOptions.plugins,
//       annotation: {
//         annotations: {
//           ideal: idealLineY,
//         },
//       },
//     },
//   };

//   const horizontalBarOptions = {
//     ...commonOptions,
//     indexAxis: "y",
//     scales: {
//       x: { beginAtZero: true, max: 100 },
//     },
//     plugins: {
//       datalabels: {
//         display: true,
//         anchor: "end",
//         align: "right",
//         formatter: (v) => v.toFixed(2),
//       },
//       annotation: {
//         annotations: {
//           ideal: idealLineX,
//         },
//       },
//     },
//   };

//   const lineOptions = {
//     ...commonOptions,
//     scales: {
//       y: { beginAtZero: true, max: 100 },
//     },
//     plugins: {
//       ...commonOptions.plugins,
//       annotation: {
//         annotations: {
//           ideal: idealLineY,
//         },
//       },
//     },
//   };

//   return (
//     <div style={{ padding: 10 }}>
//       <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//         <Typography variant="h5">PR Comparison</Typography>

//         <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//           <Tab label="Bar" />
//           <Tab label="Horizontal" />
//           <Tab label="Line" />
//         </Tabs>
//       </Box>

//       <Box sx={{ display: "flex", gap: 1, my: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />

//         <TbRefresh onClick={fetchChartData} />
//         <DownloadJpegButton targetRef={chartRef} />
//       </Box>

//       <Paper ref={chartRef} sx={{ p: 2 }}>
//         <Box sx={{ height: 300 }}>
//           {loading ? (
//             <Typography>Loading...</Typography>
//           ) : chartData ? (
//             <>
//               {tab === 0 && <Bar data={chartData} options={barOptions} />}
//               {tab === 1 && (
//                 <Bar
//                   data={chartData}
//                   options={horizontalBarOptions}
//                   plugins={[ChartDataLabels]}
//                 />
//               )}
//               {tab === 2 && <Line data={chartData} options={lineOptions} />}
//             </>
//           ) : (
//             <Typography>No Data</Typography>
//           )}
//         </Box>
//       </Paper>
//     </div>
//   );
// }

// export default InvPrPerformance;


import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Line, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";
import {
  Paper,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  Tabs,
  Tab,
  Switch,
} from "@mui/material";
import { TbRefresh } from "react-icons/tb";
import { BaseUrl } from "../../../../../../api/AxiosApi";
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ✅ Register plugins
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  annotationPlugin
);

function getDateTimeForDashboardTab1(date = new Date()) {
  const today = date.toISOString().split("T")[0];
  const lastWeek = new Date(date);
  lastWeek.setDate(lastWeek.getDate() - 7);

  return {
    Today: today,
    LastWeek: lastWeek.toISOString().split("T")[0],
  };
}

// function InvPrPerformance() {
//   const chartRef = useRef();

//   const [tab, setTab] = useState(0);
//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [selectAll, setSelectAll] = useState(false);

//   const [fromDate, setFromDate] = useState(
//     getDateTimeForDashboardTab1().LastWeek
//   );
//   const [toDate, setToDate] = useState(
//     getDateTimeForDashboardTab1().Today
//   );
//   const [idealValue, setIdealValue] = useState(80);
//   const [loading, setLoading] = useState(false);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID"),
//     LOC_CODE: localStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     TYP: "I",
//   };

//   // 🔹 Fetch Inverters
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           { params: credentials }
//         );

//         const list = res.data.FEED || [];
//         setInverters(list);

//         if (list.length > 0) {
//           setSelectedKeys([list[0].feeder_id]);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (checked) => {
//     setSelectAll(checked);
//     setSelectedKeys(
//       checked ? inverters.map((i) => i.feeder_id) : []
//     );
//   };

//   useEffect(() => {
//     setSelectAll(
//       selectedKeys.length === inverters.length &&
//       inverters.length > 0
//     );
//   }, [selectedKeys, inverters]);

//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   // 🔹 Fetch Data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) return;

//     setLoading(true);

//     try {
//       let labels = [];
//       let datasets = [];

//       const baseRes = await axios.get(
//         `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//         {
//           params: {
//             ...credentials,
//             MTR_NO: selectedKeys[0],
//             DT1: fromDate,
//             DT2: toDate,
//           },
//         }
//       );

//       const baseData = baseRes.data.data || [];
//       labels = baseData.map((d) => d.DATET);

//       for (const inv of inverters) {
//         if (!selectedKeys.includes(inv.feeder_id)) continue;
//         // console.log("feederid",inv.feeder_id)

//         const res = await axios.get(
//           `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
//           {
//             params: {
//               ...credentials,
//               MTR_NO: inv.feeder_id,
//               DT1: fromDate,
//               DT2: toDate,
//             },
//           }
//         );

//         const apiData = res.data.data || [];

//         const dataMap = {};
//         apiData.forEach((d) => {
//           dataMap[d.DATET] = parseFloat(d.PR) || 0;
//         });

//         datasets.push({
//           label: inv.name,
//           data: labels.map((l) => dataMap[l] || 0),
//           borderColor: "#" + ((Math.random() * 0xffffff) << 0).toString(16),
//           backgroundColor: "#" + ((Math.random() * 0xffffff) << 0).toString(16),
//           tension: 0.4,
//           pointRadius: 3,
//         });
//       }

//       setChartData({ labels, datasets });
//     } catch (err) {
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchChartData();
//   }, [selectedKeys, idealValue]);

//   // 🔥 Ideal Lines
//   const idealLineY = {
//     type: "line",
//     yMin: idealValue,
//     yMax: idealValue,
//     borderColor: "red",
//     borderWidth: 2,
//     borderDash: [6, 6],
//     label: {
//       display: true,
//       content: `Ideal: ${idealValue}`,
//     },
//   };

//   const idealLineX = {
//     type: "line",
//     xMin: idealValue,
//     xMax: idealValue,
//     borderColor: "red",
//     borderWidth: 2,
//     borderDash: [6, 6],
//     label: {
//       display: true,
//       content: `Ideal: ${idealValue}`,
//     },
//   };

//   // 🔹 Chart Options
//   const commonOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       datalabels: { display: false },
//     },
//   };

//   const barOptions = {
//     ...commonOptions,
//     scales: {
//       y: { beginAtZero: true, max: 100 },
//     },
//     plugins: {
//       ...commonOptions.plugins,
//       annotation: { annotations: { ideal: idealLineY } },
//     },
//   };

//   const horizontalBarOptions = {
//     ...commonOptions,
//     indexAxis: "y",
//     scales: {
//       x: { beginAtZero: true, max: 100 },
//     },
//     plugins: {
//       datalabels: {
//         display: true,
//         anchor: "end",
//         align: "right",
//         formatter: (v) => v.toFixed(2),
//       },
//       annotation: { annotations: { ideal: idealLineX } },
//     },
//   };

//   const lineOptions = {
//     ...commonOptions,
//     scales: {
//       y: { beginAtZero: true, max: 100 },
//     },
//     plugins: {
//       ...commonOptions.plugins,
//       annotation: { annotations: { ideal: idealLineY } },
//     },
//   };

//   return (
//     <div style={{ padding: 10 }}>
//       {/* Header */}
//       <Box sx={{ display: "flex", justifyContent: "space-between" }}>
//         <Typography variant="h5">Inverter Wise PR Comparison</Typography>

//         <Tabs value={tab} onChange={(e, v) => setTab(v)}>
//           <Tab label="Bar" />
//           <Tab label="Horizontal" />
//           <Tab label="Line" />
//         </Tabs>
//       </Box>

//       {/* 🔹 Inverter Selection */}
//       <Paper sx={{ p: 2, my: 2 }}>
//         <FormControlLabel
//           control={
//             <Switch
//               checked={selectAll}
//               onChange={(e) => handleSelectAll(e.target.checked)}
//             />
//           }
//           label="Select All Inverters"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap", maxHeight: 150, overflowY: "auto" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>
//       </Paper>

//       {/* Controls */}
//       <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//         <TextField
//           size="small"
//           label="Ideal"
//           type="number"
//           value={idealValue}
//           onChange={(e) => setIdealValue(e.target.value)}
//         />


//         <TbRefresh
//           onClick={fetchChartData}
//           style={{ cursor: "pointer", fontSize: "28px" }}
//         />
//         <DownloadJpegButton targetRef={chartRef} />
//       </Box>

//       {/* Chart */}
//       <Paper ref={chartRef} sx={{ p: 2 }}>
//         <Box sx={{ height: 300 }}>
//           {loading ? (
//             <Typography align="center">Loading...</Typography>
//           ) : chartData ? (
//             <>
//               {tab === 0 && <Bar data={chartData} options={barOptions} />}
//               {tab === 1 && (
//                 <Bar
//                   data={chartData}
//                   options={horizontalBarOptions}
//                   plugins={[ChartDataLabels]}
//                 />
//               )}
//               {tab === 2 && <Line data={chartData} options={lineOptions} />}
//             </>
//           ) : (
//             <Typography align="center">No Data</Typography>
//           )}
//         </Box>
//       </Paper>
//     </div>
//   );
// }

// export default InvPrPerformance;


// ... keep all imports the same

function InvPrPerformance() {
  const chartRef = useRef();

  const [tab, setTab] = useState(0);
  const [inverters, setInverters] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [selectAll, setSelectAll] = useState(false);

  const [fromDate, setFromDate] = useState(
    getDateTimeForDashboardTab1().LastWeek
  );
  const [toDate, setToDate] = useState(
    getDateTimeForDashboardTab1().Today
  );
  const [idealValue, setIdealValue] = useState(80);
  const [loading, setLoading] = useState(false);

  const credentials = {
    LOGIN_ID: localStorage.getItem("LoginID"),
    LOC_CODE: localStorage.getItem("LCODE"),
    PASS_KEY: "XYZ",
    WEB_KEY: "WEBXYZ321",
    TYP: "I",
  };

  // 🔹 Fetch Inverters
  useEffect(() => {
    async function fetchInverters() {
      try {
        const res = await axios.get(
          `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
          { params: credentials }
        );

        const list = res.data.FEED || [];
        setInverters(list);

        if (list.length > 0) {
          setSelectedKeys([list[0].feeder_id]);
        }
      } catch (err) {
        console.error(err);
      }
    }

    fetchInverters();
  }, []);

  // 🔹 Select All
  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    setSelectedKeys(
      checked ? inverters.map((i) => i.feeder_id) : []
    );
  };

  useEffect(() => {
    setSelectAll(
      selectedKeys.length === inverters.length &&
      inverters.length > 0
    );
  }, [selectedKeys, inverters]);

  const handleToggle = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key)
        ? prev.filter((k) => k !== key)
        : [...prev, key]
    );
  };

  // 🔹 Fetch Data
  const fetchChartData = async () => {
    if (selectedKeys.length === 0) return;

    setLoading(true);

    try {
      let labels = [];
      let datasets = [];

      const baseRes = await axios.get(
        `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
        {
          params: {
            ...credentials,
            MTR_NO: selectedKeys[0],
            DT1: fromDate,
            DT2: toDate,
          },
        }
      );

      const baseData = baseRes.data.data || [];
      labels = baseData.map((d) => d.DATET);

      for (const inv of inverters) {
        if (!selectedKeys.includes(inv.feeder_id)) continue;

        const res = await axios.get(
          `${BaseUrl}CMN_08InvLog/Get_Inv_Perf`,
          {
            params: {
              ...credentials,
              MTR_NO: inv.feeder_id,
              DT1: fromDate,
              DT2: toDate,
            },
          }
        );

        const apiData = res.data.data || [];

        const dataMap = {};
        apiData.forEach((d) => {
          dataMap[d.DATET] = parseFloat(d.PR) || 0;
        });

        datasets.push({
          label: inv.name,
          data: labels.map((l) => dataMap[l] || 0),
          borderColor: "#" + ((Math.random() * 0xffffff) << 0).toString(16),
          backgroundColor: "#" + ((Math.random() * 0xffffff) << 0).toString(16),
          tension: 0.4,
          pointRadius: 3,
        });
      }

      setChartData({ labels, datasets });
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchChartData();
  }, [selectedKeys, idealValue, fromDate, toDate]); // 🔹 Added date dependency

  // 🔥 Ideal Lines
  const idealLineY = {
    type: "line",
    yMin: idealValue,
    yMax: idealValue,
    borderColor: "red",
    borderWidth: 2,
    borderDash: [6, 6],
    label: {
      display: true,
      content: `Ideal: ${idealValue}`,
    },
  };

  const idealLineX = {
    type: "line",
    xMin: idealValue,
    xMax: idealValue,
    borderColor: "red",
    borderWidth: 2,
    borderDash: [6, 6],
    label: {
      display: true,
      content: `Ideal: ${idealValue}`,
    },
  };

  const commonOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: { display: false },
    },
  };

  const barOptions = {
    ...commonOptions,
    scales: { y: { beginAtZero: true, max: 100 } },
    plugins: { ...commonOptions.plugins, annotation: { annotations: { ideal: idealLineY } } },
  };

  const horizontalBarOptions = {
    ...commonOptions,
    indexAxis: "y",
    scales: { x: { beginAtZero: true, max: 100 } },
    plugins: {
      datalabels: { display: true, anchor: "end", align: "right", formatter: (v) => v.toFixed(2) },
      annotation: { annotations: { ideal: idealLineX } },
    },
  };

  const lineOptions = {
    ...commonOptions,
    scales: { y: { beginAtZero: true, max: 100 } },
    plugins: { ...commonOptions.plugins, annotation: { annotations: { ideal: idealLineY } } },
  };

  return (
    <div style={{ padding: 10 }}>
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h5">Inverter Wise PR Comparison</Typography>
        <Tabs value={tab} onChange={(e, v) => setTab(v)}>
          <Tab label="Bar" />
          <Tab label="Horizontal" />
          <Tab label="Line" />
        </Tabs>
      </Box>

      {/* 🔹 Inverter Selection */}
      <Paper sx={{ p: 2, my: 2 }}>
        <FormControlLabel
          control={<Switch checked={selectAll} onChange={(e) => handleSelectAll(e.target.checked)} />}
          label="Select All Inverters"
        />
        <Box sx={{ display: "flex", flexWrap: "wrap", maxHeight: 150, overflowY: "auto" }}>
          {inverters.map((inv) => (
            <FormControlLabel
              key={inv.feeder_id}
              control={<Checkbox checked={selectedKeys.includes(inv.feeder_id)} onChange={() => handleToggle(inv.feeder_id)} />}
              label={inv.name}
            />
          ))}
        </Box>
      </Paper>

      {/* Controls */}
      <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
        <TextField
          size="small"
          label="From"
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          size="small"
          label="To"
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          size="small"
          label="Ideal"
          type="number"
          value={idealValue}
          onChange={(e) => setIdealValue(e.target.value)}
        />
        <TbRefresh onClick={fetchChartData} style={{ cursor: "pointer", fontSize: "28px" }} />
        <DownloadJpegButton targetRef={chartRef} />
      </Box>

      {/* Chart */}
      <Paper ref={chartRef} sx={{ p: 2 }}>
        <Box sx={{ height: 300 }}>
          {loading ? (
            <Typography align="center">Loading...</Typography>
          ) : chartData ? (
            <>
              {tab === 0 && <Bar data={chartData} options={barOptions} />}
              {tab === 1 && <Bar data={chartData} options={horizontalBarOptions} plugins={[ChartDataLabels]} />}
              {tab === 2 && <Line data={chartData} options={lineOptions} />}
            </>
          ) : (
            <Typography align="center">No Data</Typography>
          )}
        </Box>
      </Paper>
    </div>
  );
}

export default InvPrPerformance;